module.exports = __webpack_public_path__ + "img/syl_main1.ca68137a.jpg";